<template>
	<Col>
		<AnalyticsDashboardRightSideTopSection class="mb-5" />
		<AnalyticsLatestErrorsCard />
	</Col>
</template>
<script>
import AnalyticsLatestErrorsCard from '@/components/Analytics/Cards/AnalyticsLatestErrorsCard.vue';
import AnalyticsDashboardRightSideTopSection from '@/components/Analytics/Dashboard/RightSide/AnalyticsDashboardRightSideTopSection.vue';
export default {
	name: 'AnalyticsDashboardRightSide',
	components: { AnalyticsDashboardRightSideTopSection, AnalyticsLatestErrorsCard },
};
</script>
<style scoped lang="scss"></style>
